export const VIEWS = {
    OVERVIEW: 'overview',
    FORM: 'form',
    DETAILS: 'details',
};